import React from 'react'
import CommunityPostsListing from './CommunityPostsListing'

const CommunityTopTeams = () => (
  <CommunityPostsListing
    postType="round_top_teams"
    title="Top Teams Posts"
    subtitle="The best-performing teams shared after each round."
  />
)

export default CommunityTopTeams
